import { SWRConfiguration, SWRResponse } from 'swr';
import { GetPatientAllocationFactorsResponse, GetPatientAllocationFactors } from '../../api/dtos';
import { useMemo } from 'react';
import { useGet } from '@ngt/opms';

export const PICF_VERSION_OTHER_ID = 0;

const getData = (response?: SWRResponse<GetPatientAllocationFactorsResponse, GetPatientAllocationFactorsResponse>) => response?.data?.patientAllocationFactors;

const getError = (response?: SWRResponse<GetPatientAllocationFactorsResponse, GetPatientAllocationFactorsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const usePatientAllocationFactors = (patientId?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return patientId ?
            () => {
                return new GetPatientAllocationFactors({ patientId });
            } :
            undefined;
    }, [patientId])

    return useGet(request, { getData, getError }, configuration);
};

export default usePatientAllocationFactors;